import { initContract } from "@ts-rest/core";
import { adpRunCreateConnectionBodySchema } from "@common/schemas/domains/adpRun/adp-run-connection.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { IntegrationConnectionDto } from "../dto/integrationConnection/integration-connection.dto";

const c = initContract();

export const adpRunIntegrationContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: adpRunCreateConnectionBodySchema,
            responses: {
                200: c.type<IntegrationConnectionDto>(),
                201: c.type<IntegrationConnectionDto>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/adp-run",
    },
);
